import { DateTime } from 'luxon';

const initializeDateTimeFromIso = (dateTime) => {
  return DateTime.fromISO(dateTime);
};

// format 26/11/2020
export function formatDate(dateTime) {
  const date = initializeDateTimeFromIso(dateTime);
  return date.toLocaleString(DateTime.DATE_SHORT);
}



// WEBPACK FOOTER //
// ./src/util/date.js